<!-- simple-menu.component.html -->
<mat-toolbar class="white-toolbar" [ngClass]="mat_tools">


  <!-- Left side: Title and Menu -->
  <div class="left-section">
    <!-- Title -->
    <div *ngIf="title" class="toolbar-title">
      <span class="title-text">{{ title }}</span>
    </div>

    <!-- Menu items -->
    <div class="menu-wrapper" *ngIf="menus?.length > 0">
      <ng-container *ngFor="let item of menus">
        <!-- Dropdown menu -->
        <ng-container *ngIf="item?.items?.length > 0">
          <app-menu-item #menu [items]="item.items"></app-menu-item>
          <!-- Blocked by the "load a track first" guard: render WITHOUT any menu trigger so
               the center menu cannot open; clicking only surfaces the warning. -->
          <button mat-button *ngIf="isBlocked(item)" (click)="notifyBlocked()"
            [ngStyle]="topStyle(item)" [attr.title]="item.tooltip || item.label || ''">
            <ng-container *ngIf="item.icon">
              <img *ngIf="isImageIcon(item.icon)" [src]="item.icon" class="menu-btn-img" alt="" />
              <mat-icon *ngIf="!isImageIcon(item.icon)" class="menu-btn-icon">{{ item.icon }}</mat-icon>
            </ng-container>
            <span *ngIf="item.label">{{ item.label }}</span>
          </button>
          <!-- Normal dropdown trigger (guard inactive or allow-listed). -->
          <button mat-button *ngIf="!isBlocked(item) && menu?.childMenu" [matMenuTriggerFor]="menu.childMenu"
            #topTrigger="matMenuTrigger" (menuOpened)="closeOtherMenus(topTrigger)"
            [ngStyle]="topStyle(item)" [attr.title]="item.tooltip || item.label || ''">
            <ng-container *ngIf="item.icon">
              <img *ngIf="isImageIcon(item.icon)" [src]="item.icon" class="menu-btn-img" alt="" />
              <mat-icon *ngIf="!isImageIcon(item.icon)" class="menu-btn-icon">{{ item.icon }}</mat-icon>
            </ng-container>
            <span *ngIf="item.label">{{ item.label }}</span>
          </button>
        </ng-container>

        <!-- Leaf node -->
        <ng-container *ngIf="!item.items || item.items.length === 0">
          <!-- Icon-only button -->
          <button *ngIf="item.icon && !item.label" mat-icon-button (click)="click(item)"
            (mouseenter)="hover(item)" [ngStyle]="{ 'color': item.color || menu_button_color }"
            [attr.title]="item.tooltip || item.hint || ''">
            <img *ngIf="isImageIcon(item.icon)" [src]="item.icon" class="menu-btn-img" alt="" />
            <mat-icon *ngIf="!isImageIcon(item.icon)">{{ item.icon }}</mat-icon>
          </button>
          <!-- Text button (optional leading icon) -->
          <button *ngIf="item.label" mat-button (click)="click(item)"
            (mouseenter)="hover(item)" [ngStyle]="{ 'color': item.color || menu_button_color }"
            [attr.title]="item.tooltip || item.hint || ''">
            <ng-container *ngIf="item.icon">
              <img *ngIf="isImageIcon(item.icon)" [src]="item.icon" class="menu-btn-img" alt="" />
              <mat-icon *ngIf="!isImageIcon(item.icon)" class="menu-btn-icon">{{ item.icon }}</mat-icon>
            </ng-container>
            <span class="menu-btn-label">{{ item.label }}</span>
          </button>
        </ng-container>
      </ng-container>
    </div>

    <!-- Icon / text buttons -->
    <div class="menu-buttons" *ngIf="buttons?.length > 0">
      <ng-container *ngFor="let btn of buttons">
        <!-- Group separator -->
        <span *ngIf="btn.separator || btn.type === 'separator'" class="menu-btn-sep" aria-hidden="true"></span>
        <!-- Icon button (image or material ligature); label becomes the tooltip -->
        <button *ngIf="btn.icon" mat-icon-button (click)="click(btn)" (mouseenter)="hover(btn)"
          [ngStyle]="{ 'color': btn.color || menu_button_color }"
          [attr.title]="btn.tooltip || btn.label || btn.hint || ''">
          <img *ngIf="isImageIcon(btn.icon)" [src]="btn.icon" class="menu-btn-img" alt="" />
          <mat-icon *ngIf="!isImageIcon(btn.icon)">{{ btn.icon }}</mat-icon>
        </button>
        <!-- Text-only button -->
        <button *ngIf="!btn.icon && btn.label" mat-button (click)="click(btn)" (mouseenter)="hover(btn)"
          [ngStyle]="{ 'color': btn.color || menu_button_color }"
          [attr.title]="btn.tooltip || btn.hint || ''">
          <span class="menu-btn-label">{{ btn.label }}</span>
        </button>
      </ng-container>
    </div>
  </div>

  <!-- Right side: Command input with highlighted display text -->
  <span *ngIf="cmd && isPrimaryCommandInput" class="span-container">
    <mat-form-field appearance="outline" class="compact-text-field highlight-wrapper">
      <!-- Overlay that mirrors input value and applies bracket highlighting -->
      <div class="highlight-display" [class.is-empty]="!cmdCtrl?.value"
        [innerHTML]="cmdCtrl?.value ? (cmdCtrl.value | highlightBrackets) : placeholder" aria-hidden="true"></div>

      <input matInput #textInput [formControl]="cmdCtrl" [placeholder]="placeholder" autocomplete="off"
        (input)="onKeyUp($event); $event.stopPropagation()"
        (click)="onKeyUp($event); $event.stopPropagation()"
        (keydown)="onCmdKeyDown($event)" (keyup)="$event.stopPropagation()"
        (keypress)="$event.stopPropagation()"
        (focus)="caretInWindow = true" (blur)="caretInWindow = false"
        spellcheck="false" autocorrect="off"
        autocapitalize="off" />


      <!-- Inline "Save" button -->
      <button mat-icon-button matSuffix color="primary" aria-label="Save" (click)="submitText()">
        <mat-icon>thumb-up</mat-icon>
      </button>




    </mat-form-field>
  </span>

  <!-- The completion list is the shared one (suggest-list.ts): it builds its own panel
       on <body>, so the toolbar's overflow cannot clip it, and it carries its own CSS and
       key handling. What this component supplies is the candidates and what a pick means. -->

</mat-toolbar>